import type {
  MaxLengthValidationError,
  MaxValidationError,
  MinLengthValidationError,
  MinValidationError,
} from '@angular/forms/signals';
import { KIT_SIGNAL_FORM_ERROR_MESSAGE_RESOLVER, provideKitIonicSignalForms } from '@rdlabo/ionic-angular-kit/forms';
import type { KitSignalFormErrorMessageResolver } from '@rdlabo/ionic-angular-kit/forms';

export const japaneseFormErrorMessage: KitSignalFormErrorMessageResolver = (error) => {
  switch (error.kind) {
    case 'required':
      return '入力または選択してください。';
    case 'email':
      return '正しいメールアドレスを入力してください。';
    case 'min':
      return `${(error as MinValidationError).min}以上で入力してください。`;
    case 'max':
      return `${(error as MaxValidationError).max}以下で入力してください。`;
    case 'minLength':
      return `${(error as MinLengthValidationError).minLength}文字以上で入力してください。`;
    case 'maxLength':
      return `${(error as MaxLengthValidationError).maxLength}文字以内で入力してください。`;
    default:
      return '入力内容を確認してください。';
  }
};

export const provideOdssSignalForms = () => [
  provideKitIonicSignalForms(),
  { provide: KIT_SIGNAL_FORM_ERROR_MESSAGE_RESOLVER, useValue: japaneseFormErrorMessage },
];
